

const Cart = ({ isOpen, toggleCart, cartItems, updateQuantity, removeItem, clearCart, openOrderModal }) => {
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  return (
    <div className={`cart-sidebar ${isOpen ? 'open' : ''}`}>
      <div className="cart-header">
        <h2>
          <i className="fas fa-shopping-cart"></i> Your Cart
        </h2>
        <button className="close-cart" onClick={toggleCart}>
          <i className="fas fa-times"></i>
        </button>
      </div>
      
      {cartItems.length === 0 ? (
        <div className="empty-cart">
          <i className="fas fa-shopping-cart empty-cart-icon"></i>
          <p>Your cart is empty</p>
          <p>Add some eggcellent products!</p>
        </div>
      ) : (
        <>
          <div className="cart-items">
            {cartItems.map(item => (
              <div key={item.id} className="cart-item">
                <div className="cart-item-image">
                  <img src={item.image} alt={item.name} />
                </div>
                <div className="cart-item-details">
                  <h4 className="cart-item-name">{item.name}</h4>
                  <p className="cart-item-price">₹{item.price.toFixed(2)} each</p>
                </div>
                <div className="cart-item-quantity">
                  <button 
                    className="quantity-btn" 
                    onClick={() => updateQuantity(item.id, item.quantity - 1)}
                  >
                    <i className="fas fa-minus">-</i>
                  </button>
                  <span className="quantity">{item.quantity}</span>
                  <button 
                    className="quantity-btn" 
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                  >
                    <i className="fas fa-plus">+</i>
                  </button>
                </div>
                <div className="cart-item-total">
                  <p>₹{(item.price * item.quantity).toFixed(2)}</p>
                  <button 
                    className="remove-btn"
                    onClick={() => removeItem(item.id)}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          <div className="cart-footer">
            <div className="cart-total">
              <span>Total:</span>
              <span className="total-price">₹{calculateTotal().toFixed(2)}</span>
            </div>
            <div className="cart-actions">
              <button className="clear-cart-btn" onClick={clearCart}>
                Clear Cart
              </button>
              <button className="checkout-btn" onClick={openOrderModal}>
                <i className="fab fa-whatsapp whatsapp-icon"></i> Checkout via WhatsApp
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;